const Menu =  [
{ header: 'Apps' },
{
  title: 'Dashboard',
  group: 'apps',
  icon: 'dashboard',
  name: 'Dashboard',
},
{
  title: 'Empresas',
  group: 'apps',
  icon: 'assignment_ind',
  name: 'Empresas',
  component: 'components/empresas/Empresas'
},     
{
  title: 'Treinamentos',
  group: 'apps',
  icon: 'subscriptions',
  name: 'Treinamentos',
},    
{
  title: 'Turmas',
  group: 'apps',
  icon: 'gavel',
  name: 'Turmas',
},  
{
  title: 'Instrutores',
  group: 'apps',
  icon: 'assignment_ind',
  name: 'Instrutores',
},
{
  title: 'Agendamentos',
  group: 'apps',
  icon: 'alarm',
  items: [
      { name: 'Day', title: 'Desativar Dias', component: 'agendamentos/Day' },
      { name: 'Agendamentos', title: 'Marcados', component: 'agendamentos/Agendamentos' },
      { name: 'Agendar', title: 'Agendar', component: 'agendamentos/Agendar' }
    ]
},   
{
  title: 'Usuários',
  group: 'apps',
  icon: 'assignment_ind',
  name: 'Usuarios',
},   
 
  { divider: true },
  ];
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js